import { FC, SVGProps } from "react";
import { SEAT_SYMBOL_ID } from "./SeatSymbolDefs";

const SeatUseIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 52 52" {...props}>
      <use href={`#${SEAT_SYMBOL_ID}`} />
    </svg>
  );
};

export default SeatUseIcon;
